import { RouteConfig } from 'vue-router'
import i18n from '@/i18n'

const routes: Array<RouteConfig> = [
    {
        path: '/accounts',
        name: 'accounts',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/account/views/Accounts.vue')
    },
    {
        path: '/account/campaigns',
        name: 'account_campaigns',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/account/views/Campaigns.vue')
    }
]

export default routes
